module.exports = __webpack_public_path__ + "static/decliningScore-2900f1cf3002779e312e7e9c89b14927.png";